import Vue from 'vue'
import Router from 'vue-router'
// Components
import ContentsManage from '@/components/manager/ContentsManage.vue'
import ArticleEditor from '@/components/editor/ArticleEditor.vue'
import PreviewPageVue from '../components/preview/PreviewPage.vue'

// ルーターをインストール
Vue.use(Router)

export default new Router({
  base: '/app/',
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    { name: 'contents-manage', path: '/sites/:kajiki_id(\\d+)/contents/', component: ContentsManage },
    { name: 'editor-new', path: '/sites/:kajiki_id(\\d+)/contents/new', component: ArticleEditor, meta: { type: 'content-editor' } },
    {
      name: 'editor-new-without-loading',
      path: '/sites/:kajiki_id(\\d+)/contents/new',
      component: ArticleEditor,
      props: { skipLoading: true },
      meta: { type: 'content-editor' }
    },
    {
      name: 'editor-update',
      path: '/sites/:kajiki_id(\\d+)/contents/:content_id(\\d+)',
      component: ArticleEditor,
      meta: { type: 'content-editor' }
    },
    {
      name: 'editor-update-without-loading',
      path: '/sites/:kajiki_id(\\d+)/contents/:content_id(\\d+)',
      component: ArticleEditor,
      props: { skipLoading: true },
      meta: { type: 'content-editor' }
    },
    {
      name: 'editor-restore-backup',
      path: '/sites/:kajiki_id(\\d+)/contents/new',
      component: ArticleEditor,
      props: { restoreFromBackup: true },
      meta: { type: 'content-editor' }
    },
    { name: 'preview-page', path: '/sites/:kajiki_id(\\d+)/contents/:content_id(\\d+)/preview', component: PreviewPageVue }
  ]
})
